export default __webpack_public_path__ + "static/media/Checkmark.087ff8fe.svg";